import { OrderSubscriptionFlow } from "../../order/OrderSubscriptionCard"
import { LICENSING_MODE_GROUP_SUBSCRIPTION } from "../../store/resource/offering/license/constants"
import { getIsSubscriptionUsable } from "../../subscription/utils"
import { useUserCommunityContext } from "../../user/UserCommunityContext"

/**
 * Group-subscription subscribe gate.
 *
 * - paymentType === "subscription" → gate until in a usable included group sub
 * - paymentType === "free" | "one_off" → skip gate
 * - paymentType undefined (ResourceAbout) → gate until in plan (today's UX)
 */
const LicenseResourceGroupSubscriptionGate = ({
  licenseOffering,
  children,
  redirectTo,
  paymentType
}) => {
  const isGroupSubscription =
    licenseOffering.licensing_mode === LICENSING_MODE_GROUP_SUBSCRIPTION

  const normalizedPaymentType = paymentType
    ? String(paymentType).toLowerCase()
    : undefined

  // free / one_off skip; subscription or undefined (ResourceAbout) gate.
  const shouldGateOnSubscription =
    normalizedPaymentType !== "free" && normalizedPaymentType !== "one_off"

  const { communityGroups, hasActiveMembership } = useUserCommunityContext()

  let isIncludedInGroupSubscription = false
  const includedInProductIds = licenseOffering.include_with_products.map(
    (product) => product.id
  )

  // Same logic as in ResourceOfferingFormContainer.js
  communityGroups.forEach((communityGroup) => {
    const groupSubscription = communityGroup.group_subscription
    if (
      // if group subscription is to a product that includes this offering
      includedInProductIds.includes(groupSubscription.price.product.id) &&
      // and the group subscription is active
      getIsSubscriptionUsable(groupSubscription.subscription) &&
      // and the user's membership is active
      hasActiveMembership(groupSubscription.community_group) &&
      groupSubscription.community_group.seats_available > -1
    ) {
      // then this offering is included in group subscription
      isIncludedInGroupSubscription = true
    }
  })

  const needsToSubscribe =
    isGroupSubscription &&
    shouldGateOnSubscription &&
    !isIncludedInGroupSubscription

  if (needsToSubscribe) {
    return (
      <OrderSubscriptionFlow
        productIds={
          includedInProductIds.length ? includedInProductIds : undefined
        }
        planIds={[]}
        redirectTo={redirectTo}
      />
    )
  }

  return children
}

LicenseResourceGroupSubscriptionGate.displayName =
  "LicenseResourceGroupSubscriptionGate"

export default LicenseResourceGroupSubscriptionGate
